import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ToastError500 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
      <Icon path={mdiInformationOutline} size={2} color={theme.palette.text.primary} />
      <br />
      <Typography variant="h6" align="center" color={theme.palette.text.primary}>
        {t("toast.error_500_title")}
      </Typography>
      <br />
      <Typography variant="h6" align="center" color={theme.palette.text.primary}>
        {t("toast.error_500_description")}
      </Typography>
    </Box>
  );
};

// Usage
/*
  toast(<ToastError500 />, {
    duration: 6000,
  });
*/
